"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _utils = require("@/utils");
var _hike = require("@/api/hike");
var _user = require("@/api/user");
var _autoTableHeight = require("@/views/mixins/autoTableHeight");
var _index = _interopRequireDefault(require("../../../components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HikeIndex',
  components: {
    SearchBox: _index.default
  },
  mixins: [_autoTableHeight.autoTableHeight],
  filters: {
    getInternalTitle(value) {
      // console.log('row value', value)
      return typeof value === 'undefined' ? '' : value.title;
    },
    getTenantLabel: _utils.getTenantLabel,
    getProducerStaff(value, staffList) {
      const plist = _lodash.default.map(_lodash.default.flatten(_lodash.default.map(_lodash.default.filter(value, {
        role: 'producer'
      }), function (p) {
        return _lodash.default.filter(staffList, {
          user: p.user
        });
      })), function (n) {
        return n.name;
      }).toString();
      return plist;
    }
  },
  data() {
    return {
      tableLoading: false,
      copyDrawer: false,
      total: 0,
      trainingStatus: _lifehikesInitData.trainingStatus,
      hikeList: [],
      staffList: [],
      query: {
        page: 1,
        limit: 50,
        sort: '-start.utc',
        q: undefined,
        publish: undefined,
        staffUuid: undefined,
        staffRole: undefined
      },
      checked: {
        drawTitle: '',
        id: '',
        title: true,
        internalTitle: true,
        description: true,
        eventDate: true,
        stages: true,
        report: true,
        stageDate: true,
        resources: true,
        tags: true,
        webinarInfo: true,
        isFeedbackEnabled: true,
        clientName: true,
        emailSettings: true
      }
    };
  },
  async created() {
    await this.getStaffList();
    await this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    search(pageNo) {
      this.query.page = pageNo;
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      this.query.publish = this.query.publish === '' ? undefined : this.query.publish;
      this.getList();
    },
    deleteHike(id, title) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      var updatedPublishStatus = {
        id: id,
        publish: 'markdelete'
      };
      this.$confirm(`This will delete [ ${title} ]. Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        var data = {
          publish: 'markdelete'
        };
        (0, _hike.updateHikeById)(token, id, data).then(response => {
          this.search(this.query.page);
          const msg = 'Hike is deleted';
          (0, _log.displayPopupMessage)(msg, 'success');
          (0, _ga.writeGaEvent)(this, 'Hike', `${_lifehikesInitData.userEvent.hike.delete}`, oEmail, `Hike Id: ${id}`);
        }).catch(error => {
          (0, _log.displayPopupMessage)(error, 'error');
        });
      }).catch(() => {
        const msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _log.showDebugLog)('Hike query', this.query);
      (0, _hike.getHikeList)(token, this.query).then(response => {
        (0, _log.showDebugLog)('Hike-Search-response', response);
        this.hikeList = response.data.rows;
        this.total = response.data.count;
        this.tableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-Search-error', error);
        this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response })
      });
    },
    getStaffList() {
      this.loading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const query = {
        page: 1,
        limit: 100,
        role: 'otr-digital-producer',
        sort: 'givenName'
      };
      (0, _user.getUserList)(token, query).then(response => {
        this.loading = false;
        this.staffList = response.data.rows.map(s => {
          return {
            user: s.uuid,
            name: `${s.givenName} ${s.familyName}`
          };
        });

        // console.log('Staff List', this.staffList)
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)('GetUserList-api-error', error);
      });
    },
    setMyTraining() {
      if (this.query.staffUuid) {
        this.query.staffRole = 'producer';
        // this.query.staffUuid = uuid
      } else {
        this.query.staffRole = undefined;
        this.query.staffUuid = undefined;
      }
    },
    isExipred(endUtc) {
      var now = _moment.default.utc();
      var end = _moment.default.utc(endUtc);
      return now > end;
    },
    openDrawer(id, title) {
      this.copyDrawer = true;
      this.checked.drawTitle = `Copy a New Hike from [${title} (${id})]`;
      this.checked.id = id;
    },
    handleDrawClose(done) {
      this.$confirm('Are you sure you want to stop copy?').then(_ => {
        done();
      }).catch(_ => {});
    },
    copy() {
      this.copyDrawer = false;
      var link = `/hike/createfromcopy?` + `fromId=${this.checked.id}&` + `t=${this.checked.title}&` + `it=${this.checked.internalTitle}&` + `d=${this.checked.description}&` + `e=${this.checked.eventDate}&` + `s=${this.checked.stages}&` + `report=${this.checked.report}&` + `sd=${this.checked.stageDate}&` + `r=${this.checked.resources}&` + `tag=${this.checked.tags}&` + `w=${this.checked.webinarInfo}&` + `f=${this.checked.isFeedbackEnabled}&` + `cn=${this.checked.clientName}&` + `es=${this.checked.emailSettings}`;
      this.$router.push(link);
    },
    sort(data) {
      const {
        prop,
        order
      } = data;
      if (prop === 'title') {
        order === 'ascending' ? this.query.sort = '+title' : this.query.sort = '-title';
      }
      if (prop === 'start') {
        order === 'ascending' ? this.query.sort = '+start.utc' : this.query.sort = '-start.utc';
      }
      if (prop === 'end') {
        order === 'ascending' ? this.query.sort = '+end.utc' : this.query.sort = '-end.utc';
      }
      if (prop === 'description') {
        order === 'ascending' ? this.query.sort = '+description' : this.query.sort = '-description';
      }
      if (prop === 'publish') {
        order === 'ascending' ? this.query.sort = '+publish' : this.query.sort = '-publish';
      }
      if (prop === 'updatedAt') {
        order === 'ascending' ? this.query.sort = '+updatedAt' : this.query.sort = '-updatedAt';
      }
      if (prop === 'internal.title') {
        order === 'ascending' ? this.query.sort = '+internal.title' : this.query.sort = '-internal.title';
      }
      if (prop === 'internal.opportunityNumber') {
        order === 'ascending' ? this.query.sort = '+internal.opportunityNumber' : this.query.sort = '-internal.opportunityNumber';
      }
      this.search(1);
    },
    handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    downloadTASRating(row) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const id = row.id;
      this.tableLoading = true;
      (0, _hike.downloadTASRatingExcel)(token, id).then(tasRating => {
        const {
          hike,
          scores
        } = tasRating.data;
        const tasRatingData = [];
        const excelHeader = ['Rubric', 'Pax #', 'Rater', 'Event', 'Event Date', 'Rating Date', 'VIDEO'];
        excelHeader.push(...hike.videoScoreConfig.map(config => config.title));
        //  console.info(hike)
        //  console.info(scores)
        scores.forEach(report => {
          report.videoScores.forEach(video => {
            let scoreGot = 0;
            // scores
            if (video.scores && video.scores.length > 0) {
              scoreGot = video.scores.length;
              video.scores.forEach(score => {
                if (score.scores === undefined || score.scores.length === 0) {
                  return;
                }
                const row = [hike.rubricId ? hike.rubricId : '',
                // Rubric
                report.uuid,
                // Pax #
                score.rater,
                // Rater
                hike.title,
                // Event
                video.content && video.content.createdAt ? _moment.default.utc(video.content.createdAt).format('M/D/YYYY') : '',
                // Event Date
                _moment.default.utc(score.createdAt).format('M/D/YYYY'),
                // Rating Date
                video.actionTitle // VIDEO
                ];
                row.push(...hike.videoScoreConfig.map(config => {
                  // debugger
                  const scores = hike.skillCompassDimensions !== 'auto' ? score.results : score.scores;
                  const matchingScore = scores.find(score => score.key === config.key);
                  if (matchingScore) {
                    return matchingScore.score;
                  } else {
                    return '-';
                  }
                }));
                tasRatingData.push(row);
              });
            }
            // Waiting Score
            for (let _ = 0; _ < report.raterTotal - scoreGot; _++) {
              const row = [hike.rubricId ? hike.rubricId : '',
              // Rubric
              report.uuid,
              // Pax #
              'Waiting Score',
              // Rater
              hike.title,
              // Event
              video.content && video.content.createdAt ? _moment.default.utc(video.content.createdAt).format('M/D/YYYY') : '',
              // Event Date
              '',
              // Rating Date
              video.actionTitle // VIDEO
              ];
              row.push(...hike.videoScoreConfig.map(config => '-'));
              tasRatingData.push(row);
            }
          });
        });
        // Export to excel
        Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'))).then(excel => {
          excel.export_json_to_excel({
            header: excelHeader,
            data: tasRatingData,
            filename: 'TAS Rating Report'
          });
          this.tableLoading = false;
        });
      }).catch(error => {
        (0, _log.showDebugLog)('hike-api-error', error);
        this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    disableVisble(id) {
      this.$refs[id].visible = false;
    }
  }
};